import * as React from 'react';
export default parseInt(React.version, 10);